import axios from 'axios';
import { API_URL } from '../config/api';

export type Tier = 'featured' | 'premium';
export interface FeaturedPlan { id: string; tier: Tier; paidMonths: number; totalMonths: number; freeMonths: number; priceCents: number; penTest: boolean }
export interface FeaturedPlans {
    currency: string; paymentsEnabled: boolean; penTestValueCents: number; seoCheckValueCents?: number; homepageSlots: number;
    tiers: { id: Tier; monthlyCents: number; yearlyCents: number }[];
    plans: FeaturedPlan[];
}
export const tierLabel = (tier?: string | null) => (tier === 'premium' ? 'Premium' : 'Featured');
export interface FeaturedPurchase {
    id: string; plan: string; tier?: Tier; penTest?: boolean; paidMonths: number; totalMonths: number; amountCents: number; currency: string;
    status?: string; paidAt: string | null; startsAt: string | null; endsAt: string | null; createdAt?: string;
}
export interface FeaturedStatus { name: string; status: string; featured: boolean; featuredUntil: string | null; premium?: boolean; premiumUntil?: string | null; purchases: FeaturedPurchase[] }
export interface FeaturedSessionResult {
    paid: boolean; waitingForApproval?: boolean; tier?: Tier; penTest?: boolean; totalMonths: number;
    business: { id: string; name: string; slug: string | null; featuredUntil: string | null; featured: boolean } | null;
}
export interface PromotionHistoryItem extends FeaturedPurchase {
    status: string; reference: string; createdAt: string;
    business: { id: string; name: string; slug: string | null; featured: boolean; featuredUntil: string | null; premium?: boolean; premiumUntil?: string | null } | null;
}
export interface AdminFeatured { featured: boolean; featuredUntil: string | null; premium?: boolean; premiumUntil?: string | null; purchases: FeaturedPurchase[] }

export const formatAud = (cents: number) =>
    new Intl.NumberFormat('en-AU', { style: 'currency', currency: 'AUD', maximumFractionDigits: cents % 100 ? 2 : 0 }).format(cents / 100);

export const featuredService = {
    plans: async (): Promise<FeaturedPlans> => (await axios.get(`${API_URL}/featured/plans`)).data,
    premiumListings: async (): Promise<any[]> => (await axios.get(`${API_URL}/businesses-premium`)).data,
    status: async (businessId: string): Promise<FeaturedStatus> =>
        (await axios.get(`${API_URL}/businesses/${encodeURIComponent(businessId)}/featured`)).data,
    checkout: async (businessId: string, plan: string): Promise<string> =>
        (await axios.post(`${API_URL}/businesses/${encodeURIComponent(businessId)}/featured/checkout`, { plan })).data.url,
    session: async (sessionId: string): Promise<FeaturedSessionResult> =>
        (await axios.get(`${API_URL}/featured/session/${encodeURIComponent(sessionId)}`)).data,
    history: async (): Promise<PromotionHistoryItem[]> => (await axios.get(`${API_URL}/user/featured/purchases`)).data.items,
    adminGet: async (businessId: string): Promise<AdminFeatured> =>
        (await axios.get(`${API_URL}/admin/businesses/${encodeURIComponent(businessId)}/featured`)).data,
    adminGrant: async (businessId: string, months: number, tier: Tier = 'featured'): Promise<void> => {
        await axios.post(`${API_URL}/admin/businesses/${encodeURIComponent(businessId)}/featured`, { months, tier });
    },
    adminEnd: async (businessId: string): Promise<void> => {
        await axios.post(`${API_URL}/admin/businesses/${encodeURIComponent(businessId)}/featured`, { end: true });
    },
};
